<template>
  <v-dialog
    v-model="dialog"
    max-width="500px"
    scrollable>
    <template #activator="{ on, attrs }">
      <v-card
        v-if="type === 'card'"
        :ripple="false"
        class="d-flex align-center justify-center card-style font-style"
        width="247"
        height="350"
        v-bind="attrs"
        flat
        v-on="on">
        + {{ $t('papers.btn.createCard') }}
      </v-card>
      <v-btn
        v-else
        color="#43BE99"
        dark
        depressed
        v-bind="attrs"
        v-on="on">
        <v-icon
          small
          left>
          mdi-plus
        </v-icon>
        <span>{{ $t('papers.btn.create') }}</span>
      </v-btn>
    </template>
    <v-card
      color="#FBFBFB"
      flat>
      <v-card-title class="px-4">
        <title-label :label="$t('papers.form.create.title')" />
        <v-spacer />
        <v-icon
          small
          @click="setDialog(false)">
          mdi-close
        </v-icon>
      </v-card-title>
      <v-card-text class="px-4 pb-0">
        <v-form
          ref="form"
          v-model="valid"
          :readonly="submitting"
          @submit.prevent="submit()">
          <text-field-label :label="$t('papers.form.create.name')" />
          <div>
            <v-text-field
              v-model="name"
              :rules="rule.name"
              :error-messages="error.name.length ? [$t('papers.form.create.nameError')] : []"
              autocomplete="off"
              background-color="#ffffff"
              autofocus
              outlined
              dense
              @input="clearError('name')" />
          </div>
        </v-form>
      </v-card-text>
      <v-card-actions class="pb-4">
        <v-spacer />
        <v-btn
          class="px-4"
          color="primary"
          rounded
          text
          @click="setDialog(false)">
          {{ $t('app.btn.cancel') }}
        </v-btn>
        <v-btn
          :loading="submitting"
          :disabled="!valid"
          class="px-4"
          color="primary"
          rounded
          depressed
          @click="submit()">
          {{ $t('papers.form.create.submit') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import humps from 'humps'
import { CREATE_PAPER, CREATE_PAPERGROUP } from '@/resources/graphql'

export default {
  props: {
    type: {
      type: [String],
      default: 'button'
    }
  },
  data () {
    return {
      dialog: false,
      submitting: false,
      valid: true,
      name: '',
      rule: {
        name: [
          (v) => !!v || this.$t('app.validate.required')
        ]
      },
      error: {
        name: []
      }
    }
  },
  methods: {
    clearError (field) {
      this.error[field] = []
    },
    setDialog (dialog = false) {
      this.dialog = dialog
    },
    async submit () {
      if (!this.valid) return
      this.submitting = true
      const res = await this.$apollo.mutate({
        mutation: CREATE_PAPERGROUP,
        variables: {
          input: {
            name: this.name
          }
        }
      }).finally(() => {
        this.submitting = false
      })
      if (res) {
        const { data: { createPaperGroup } } = res
        if (createPaperGroup.errors && Object.keys(createPaperGroup.errors).length) {
          this.error = humps.camelizeKeys(createPaperGroup.errors)
        } else {
          await this.$apollo.mutate({
            mutation: CREATE_PAPER,
            variables: {
              input: {
                paperGroupId: createPaperGroup.paperGroup.id,
                width: 794,
                height: 1123,
                paperSize: 'A4',
                condition: 'all',
                margin: 0,
                canvas: [],
                active: true
              }
            }
          })
          this.$router.push({ name: 'Paper', params: { id: createPaperGroup.paperGroup.id } })
        }
      }
    }
  }
}
</script>

<style scoped>
  .card-style {
    background: #EAEEF5;
    border: 1px dashed #D5D5D5;
    box-sizing: border-box;
    border-radius: 2px;
  }
  .font-style {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #A2AAB8;
  }
</style>
